import { EPetFeeMethod, TByPetCountRates, TBySpeciesRates, TCustomPetFee, TPriceValue } from 'data/types/petFee.types';

export const toNum = (val: any): number | null => {
  if (val === 0) {
    return 0;
  }
  return val ? Number(val) : null;
};

const cleanPriceValue = (pv: TPriceValue): TPriceValue => ({
  value: toNum(pv.value),
  min: toNum(pv.min),
  max: toNum(pv.max),
});

const cleanSpeciesRates = (rates: TBySpeciesRates | null): TBySpeciesRates | null => {
  if (!rates) {
    return null;
  }
  return {
    entries: rates.entries
      .filter((rate) => rate?.specieName)
      .map((rate) => ({ specieName: rate.specieName, price: cleanPriceValue(rate.price) })),
  };
};

const cleanCountRates = (rates: TByPetCountRates | null): TByPetCountRates | null => {
  if (!rates) {
    return null;
  }
  return {
    firstPetPrice: cleanPriceValue(rates.firstPetPrice),
    secondPetPrice: cleanPriceValue(rates.secondPetPrice),
    eachAdditionalPetPrice: cleanPriceValue(rates.eachAdditionalPetPrice),
  };
};

export const petFeeToPayload = (fee: TCustomPetFee): TCustomPetFee => {
  switch (fee.method) {
    case EPetFeeMethod.FLAT:
      return {
        method: EPetFeeMethod.FLAT,
        flatRate: toNum(fee.flatRate),
        bySpeciesRates: null,
        byPetCountRates: null,
      };
    case EPetFeeMethod.BY_PET_SPECIES:
      return {
        method: EPetFeeMethod.BY_PET_SPECIES,
        flatRate: null,
        bySpeciesRates: cleanSpeciesRates(fee.bySpeciesRates),
        byPetCountRates: null,
      };
    case EPetFeeMethod.BY_PETS_COUNT:
      return {
        method: EPetFeeMethod.BY_PETS_COUNT,
        flatRate: null,
        bySpeciesRates: null,
        byPetCountRates: cleanCountRates(fee.byPetCountRates),
      };
    default:
      return fee;
  }
};
